module.exports = __webpack_public_path__ + "static/media/transport-styrelsen.a220a008.svg";